// src/components/User/Home/HomePage/ContactForm.js
import React, { useState } from "react";
import toast from "react-hot-toast";

const GOOGLE_FORM_URL =
    "https://docs.google.com/forms/d/e/1FAIpQLSeenfOPdV-9xITqykD9QrZDBJATHQg2iPRz8jyOv_aTJVFh2A/formResponse";

const FORM_FIELDS = {
    name: "entry.1521603342",
    phone: "entry.1304710658",
    email: "entry.258439635",
    companyName: "entry.1855215685",
    problem: "entry.2137501201",
};

const content = {
    submit: "Start a Conversation",
};

export default function ContactForm({ onSubmitSuccess, borderless = false }) {
    const [form, setForm] = useState({
        name: "",
        phone: "",
        email: "",
        companyName: "",
        problem: "",
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        let filteredValue = value;

        if (name === "name") filteredValue = value.replace(/[^a-zA-Z\s]/g, "");
        if (name === "phone") filteredValue = value.replace(/\D/g, "");

        setForm((p) => ({ ...p, [name]: filteredValue }));
        setErrors((p) => ({ ...p, [name]: "" }));
    };

    const validate = () => {
        const newErrors = {};

        if (!form.name.trim() || form.name.trim().length < 2)
            newErrors.name = "Please enter your full name.";

        // const phoneRegex = /^[1-9]\d{9}$/;
        // if (!phoneRegex.test(form.phone)) newErrors.phone = "Enter a valid 10-digit number.";

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(form.email)) newErrors.email = "Enter a valid Email Id.";

        if (!form.companyName.trim() || form.companyName.trim().length < 2)
            newErrors.companyName = "Please enter your company or brand name.";

        if (!form.problem.trim() || form.problem.trim().length < 10)
            newErrors.problem = "Briefly describe the decision you want clarity on (min 10 characters).";

        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            toast.error("Please correct the highlighted fields.");
            return;
        }

        toast.loading("Submitting...", { id: "formSubmit" });

        try {
            const formData = new FormData();
            formData.append(FORM_FIELDS.name, form.name);
            formData.append(FORM_FIELDS.phone, form.phone);
            formData.append(FORM_FIELDS.email, form.email);
            formData.append(FORM_FIELDS.companyName, form.companyName);
            formData.append(FORM_FIELDS.problem, form.problem);

            await fetch(GOOGLE_FORM_URL, { method: "POST", mode: "no-cors", body: formData });

            toast.success("Thanks. We’ll get back to you shortly.", { id: "formSubmit" });
            setForm({ name: "", phone: "", email: "", companyName: "", problem: "" });
            if (onSubmitSuccess) onSubmitSuccess();
        } catch {
            toast.error("Failed to submit. Please try again later.", { id: "formSubmit" });
        }
    };

    return (
        <form
            onSubmit={handleSubmit}
            className={`grid gap-4 text-left ${borderless ? "p-0" : "rounded-2xl p-6"}`}
            style={{
                backgroundColor: borderless ? "transparent" : "var(--bg-surface)",
                color: "var(--text-primary)",
                border: borderless ? "none" : `1px solid var(--border)`,
            }}
            noValidate
        >
            {/* Name */}
            <div>
                <label className="sr-only" htmlFor="contact-name">Your Name</label>
                <input
                    id="contact-name"
                    name="name"
                    placeholder="Your Name"
                    value={form.name}
                    onChange={handleChange}
                    maxLength={40}
                    className="w-full px-4 py-3 rounded-md text-sm placeholder:text-[var(--text-secondary)] outline-none"
                    style={{
                        border: `1px solid var(--border)`,
                        backgroundColor: "transparent",
                        color: "var(--text-primary)",
                    }}
                />
                {errors.name && (
                    <p className="text-xs mt-1" style={{ color: "var(--color-error)" }}>
                        {errors.name}
                    </p>
                )}
            </div>

            {/* Phone
            <div>
                <label className="sr-only" htmlFor="contact-phone">Phone Number</label>
                <input
                    id="contact-phone"
                    name="phone"
                    type="tel"
                    placeholder="Phone Number"
                    value={form.phone}
                    onChange={handleChange}
                    maxLength={10}
                    className="w-full px-4 py-3 rounded-md text-sm placeholder:text-[var(--text-secondary)] outline-none"
                    style={{
                        border: `1px solid var(--border)`,
                        backgroundColor: "transparent",
                        color: "var(--text-primary)",
                    }}
                />
                {errors.phone && (
                    <p className="text-xs mt-1" style={{ color: "var(--color-error)" }}>
                        {errors.phone}
                    </p>
                )}
            </div>
            */}

            {/* Email */}
            <div>
                <label className="sr-only" htmlFor="contact-email">Email Id</label>
                <input
                    id="contact-email"
                    name="email"
                    type="email"
                    placeholder="Email Id"
                    value={form.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-md text-sm placeholder:text-[var(--text-secondary)] outline-none"
                    style={{
                        border: `1px solid var(--border)`,
                        backgroundColor: "transparent",
                        color: "var(--text-primary)",
                    }}
                />
                {errors.email && (
                    <p className="text-xs mt-1" style={{ color: "var(--color-error)" }}>
                        {errors.email}
                    </p>
                )}
            </div>

            {/* Company / Brand */}
            <div>
                <label className="sr-only" htmlFor="contact-company">Business / Company / Brand Name</label>
                <input
                    id="contact-company"
                    name="companyName"
                    placeholder="Business / Company / Brand Name"
                    value={form.companyName}
                    onChange={handleChange}
                    maxLength={60}
                    className="w-full px-4 py-3 rounded-md text-sm placeholder:text-[var(--text-secondary)] outline-none"
                    style={{
                        border: `1px solid var(--border)`,
                        backgroundColor: "transparent",
                        color: "var(--text-primary)",
                    }}
                />
                {errors.companyName && (
                    <p className="text-xs mt-1" style={{ color: "var(--color-error)" }}>
                        {errors.companyName}
                    </p>
                )}
            </div>

            {/* Problem */}
            <div>
                <label className="sr-only" htmlFor="contact-problem">What growth decision are you currently thinking about?</label>
                <textarea
                    id="contact-problem"
                    name="problem"
                    placeholder="What growth decision are you currently thinking about?"
                    value={form.problem}
                    onChange={handleChange}
                    rows={4}
                    maxLength={800}
                    className="w-full px-4 py-3 rounded-md text-sm placeholder:text-[var(--text-secondary)] outline-none resize-vertical"
                    style={{
                        border: `1px solid var(--border)`,
                        backgroundColor: "transparent",
                        color: "var(--text-primary)",
                    }}
                />
                {errors.problem && (
                    <p className="text-xs mt-1" style={{ color: "var(--color-error)" }}>
                        {errors.problem}
                    </p>
                )}
            </div>

            {/* Submit */}
            <div>
                <button
                    type="submit"
                    className="w-full py-3 rounded-md font-semibold transition-transform hover:-translate-y-0.5"
                    style={{
                        backgroundColor: "var(--color-primary)",
                        color: "var(--bg-surface)",
                        border: `1px solid rgba(0,0,0,0.06)`,
                        boxShadow: "none",
                    }}
                >
                    {content.submit}
                </button>
            </div>
        </form>
    );
}
